<template>
  <div>
    <el-dialog
      :visible.sync="onlineOperationDetail.dialog"
      v-loading="dialogLoading"
      top="5vh"
      custom-class="dailogCustomerDetail"
      width="70%"
    >
      <template slot="title">
        <h1 style="margin: unset; text-align: left">การยืนยันตัวตน</h1>
      </template>
    <!-- -ประเภทบัญชี- -->
      <el-row class="online-operation-block-style">
        <el-col :span="6" class="online-operation-section-header text-left">
          ประเภทบัญชี
        </el-col>
        <el-col :span="18" class="text-left">
          <el-row :gutter="20">
            <el-col
              v-for="detail in onlineData.data"
              :key="detail.key"
              :span="detail.span"
              class="online-operation-input-block-Pich"
            >
              <el-row>
                <span>{{ detail.label }}</span>
              </el-row>
              <el-row type="flex" align="middle" justify="space-between">
                <el-input
                  :value="inputFill(detail.key, detail.onlineData)"
                  :class="{
                    'online-operation-input-invalid': !detail.isValid,
                    'online-operation-return-field': returnValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                  }"
                >
                </el-input>
                <!-- <el-button
                  style="margin-left: 15px"
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onCrossClick(detail.id)"
                ></el-button> -->
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

    <!-- -บัญชีธนาคาร- -->
      <el-row class="online-operation-block-style">
        <el-col :span="6" class="online-operation-section-header text-left">
          บัญชีธนาคาร
        </el-col>
        <el-col :span="18" class="text-left">
          <el-row :gutter="20">
            <el-col
              v-for="detail in onlineData.bankAccountInfo"
              :key="detail.key"
              :span="detail.span"
              class="online-operation-input-block-Pich"
            >
              <el-row>
                <span>{{ detail.label }}</span>
              </el-row>
              <el-row type="flex" align="middle">
                <el-input
                  :value="inputFill(detail.key, detail.onlineData)"
                  :class="{
                    'online-operation-input-invalid': !detail.isValid,
                    'online-operation-return-field': returnValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                  }"
                ></el-input>
                <!-- <el-button
                  style="margin-left: 15px"
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onBankCrossClick(detail.id)"
                ></el-button> -->
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    <!-- -ที่อยู่ปัจจุบัน- -->
      <el-row class="online-operation-block-style">
        <el-col :span="6" class="online-operation-section-header text-left">
          ที่อยู่ปัจจุบัน
        </el-col>
        <el-col :span="18" class="text-left">
          <el-row :gutter="20">
            <el-col
              v-for="detail in onlineData.currentAddressInfo"
              :key="detail.ukey"
              :span="detail.span"
              class="online-operation-input-block-Pich"
            >
              <el-row>
                <span>{{ detail.label }}</span>
              </el-row>
              <el-row type="flex" align="middle" justify="space-between">
                <el-input
                  :value="inputFill(detail.key, detail.onlineData)"
                  :class="{
                    'online-operation-input-invalid': !detail.isValid,
                    'online-operation-return-field': returnValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                  }"
                >
                </el-input>
                <!-- <el-button
                  style="margin-left: 15px"
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onCurrentAddrCrossClick(detail.id)"
                ></el-button> -->
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

    <!-- -ที่อยู่สำหรับออกใบกำกับภาษี- -->
      <el-row class="online-operation-block-style">
        <el-col :span="6" class="online-operation-section-header text-left">
          ที่อยู่สำหรับออกใบกำกับภาษี
        </el-col>
        <el-col :span="18" class="text-left">
          <el-row :gutter="20">
            <el-col
              v-for="detail in onlineData.taxInvoiceAddressInfo"
              :key="detail.key"
              :span="detail.span"
              class="online-operation-input-block-Pich"
            >
              <el-row>
                <span>{{ detail.label }}</span>
              </el-row>
              <el-row type="flex" align="middle" justify="space-between">
                <el-input
                  :value="inputFill(detail.key, detail.onlineData)"
                  :class="{
                    'online-operation-input-invalid': !detail.isValid,
                    'online-operation-return-field': returnValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                  }"
                >
                </el-input>
                <!-- <el-button
                  style="margin-left: 15px"
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onTaxAddrCrossClick(detail.id)"
                ></el-button> -->
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

    <!-- -ไฟล์รูปภาพและเอกสาร- -->
      <el-row class="online-operation-block-style" >
        <el-col :span="24" class="online-operation-section-header text-left">
          <span>ไฟล์รูปภาพและเอกสารของบุคคลทั่วไป</span><span style="color: darkgray; padding-left:5px; font-size: 14px;">*คลิกที่ภาพหรือเอกสารเพื่อดูไฟล์</span>
        </el-col>
        <!--  -->
        <el-col :span="24">
          <div class="image-row" >
            <div class="image-col"
              v-for="onlineImg in onlineData.imgArr"
              :key="onlineImg.id"
            >
              <el-row>
                <h3>{{ onlineImg.label }}</h3>
              </el-row>
              <el-row>
                <el-image
                  v-if="onlineImg.extension !== 'pdf'"
                  v-loading="imgLoading"
                  :src="onlineImg.imgPath"
                  :class="{
                    'online-operation-img':true,
                    'online-operation-img-invalid': !onlineImg.isValid,
                    'online-operation-return-field': returnValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid
                    ),
                  }"
                  @click="setPreviewImg(onlineImg.imgPath)"
                >
                </el-image>
                <img class="pdf-img"  v-if="onlineImg.extension === 'pdf'" :src="require('@/assets/PDF.png')" alt="">
              </el-row>
              <el-row class="file-name-container">
                <span v-if="onlineImg.extension === 'pdf'" class="file-name" >
                    <a :href="onlineImg.imgPath" target="_blank" >{{ onlineImg.fileName }}</a></span>
                <span v-if="onlineImg.extension !== 'pdf'" class="file-name" >{{ onlineImg.fileName }}</span>
              </el-row>
              <el-row>
                <el-button
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onImgCrossClick(onlineImg.id)"
                ></el-button>
              </el-row>
            </div>
          </div>

        </el-col>
      </el-row>

      <!-- juristicImgArr  -->
    <el-row class="online-operation-block-style" style="border-bottom: 1px dashed lightgray">
        <el-col :span="24" class="online-operation-section-header text-left">
          <span>ไฟล์รูปภาพและเอกสารของนิติบุคคล</span><span style="color: darkgray; padding-left:5px; font-size: 14px;">*คลิกที่ภาพหรือเอกสารเพื่อดูไฟล์</span>
        </el-col>
        <el-col :span="24">
          <div class="image-row" >
            <div class="image-col"
              v-for="(onlineImg,index) in onlineData.juristicImgArr"
              :key="onlineImg.id"
            >
              <el-row>
                <h3>{{ onlineImg.label }}</h3>
              </el-row>
              <el-row>
                <el-image
                  v-if="onlineImg.extension !== 'pdf'"
                  v-loading="imgLoading"
                  :src="onlineImg.imgPath"
                  :class="{
                    'online-operation-img':true,
                    'online-operation-img-invalid': !onlineImg.isValid,
                    'online-operation-return-field': returnValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid
                    ),
                  }"
                  @click="setPreviewImg(onlineImg.imgPath)"
                >
                </el-image>
                 <img  class="pdf-img" v-if="onlineImg.extension === 'pdf'" :src="require('@/assets/PDF.png')" alt="">
              </el-row>
              <el-row class="file-name-container">
                <span v-if="onlineImg.extension === 'pdf'" class="file-name" >
                    <a :href="onlineImg.imgPath" target="_blank" >{{ onlineImg.fileName }}</a></span>
                <span v-if="onlineImg.extension !== 'pdf'" class="file-name" >{{ onlineImg.fileName }}</span>
              </el-row>
              <el-row>
                <el-button
                  v-if="index != onlineData.juristicImgArr.length - 1"
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onJuristicImgCrossClick(onlineImg.id)"
                ></el-button>
              </el-row>
            </div>
          </div>

        </el-col>
      </el-row>
      <!-- commitee doc -->
      <el-row
         class="online-operation-block-style" style="border-bottom: 1px dashed lightgray">
        <el-col :span="24" class="online-operation-section-header text-left">
          <h3>ด้านหน้าบัตรประชาชนของคณะกรรมการบริษัท <span class="asterisk"> *</span></h3>
        </el-col>
        <el-col :span="24">
          <div class="image-row" >
            <div class="image-col"
              :span="6"
              v-for="onlineImg in onlineData.committeeImgArr"
              :key="onlineImg.id"
            >
              <el-row>
                <el-image
                  v-if="onlineImg.extension !== 'pdf'"
                  v-loading="imgLoading"
                  :src="onlineImg.imgPath"
                  :class="{
                    'online-operation-img':true,
                    'online-operation-img-invalid': !onlineImg.isValid,
                    'online-operation-return-field': returnValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName,
                    ),
                  }"
                  @click="setPreviewImg(onlineImg.imgPath)"
                >
                </el-image>
                <img
                :class="{
                    'pdf-img':true,
                    'online-operation-img-invalid': !onlineImg.isValid,
                    'online-operation-return-field': returnValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                       onlineImg.objectFileName
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                }"
                v-if="onlineImg.extension === 'pdf'" :src="require('@/assets/PDF.png')" alt="">
              </el-row>
              <el-row class="file-name-container">
                <span v-if="onlineImg.extension === 'pdf'" class="file-name" >
                    <a :href="onlineImg.imgPath" target="_blank" >{{ onlineImg.fileName }}</a></span>
                <span v-if="onlineImg.extension !== 'pdf'" class="file-name" >{{ onlineImg.fileName }}</span>
              </el-row>
              <el-row>
                <el-button
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onCommitteeImgCrossClick(onlineImg.id)"
                ></el-button>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- powerOfAttorneyImgArr doc -->
      <el-row
        class="online-operation-block-style" style="border-bottom: 1px dashed lightgray">
        <el-col :span="24" class="online-operation-section-header text-left">
          <h3>หนังสือมอบอำนาจ</h3>
        </el-col>
        <el-col :span="24">
          <div class="image-row" >
            <div class="image-col"
              :span="6"
              v-for="(onlineImg) in onlineData.powerOfAttorneyImgArr"
              :key="onlineImg.id"
            >
              <el-row>
                <el-image
                  v-if="onlineImg.extension !== 'pdf'"
                  v-loading="imgLoading"
                  :src="onlineImg.imgPath"
                  :class="{
                    'online-operation-img':true,
                    'online-operation-img-invalid': !onlineImg.isValid,
                    'online-operation-return-field': returnValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                  }"
                  @click="setPreviewImg(onlineImg.imgPath)"
                >
                </el-image>
                <img
                :class="{
                    'pdf-img':true,
                    'online-operation-img-invalid': !onlineImg.isValid,
                    'online-operation-return-field': returnValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                }"
                v-if="onlineImg.extension === 'pdf'" :src="require('@/assets/PDF.png')" alt="">
              </el-row>
              <el-row class="file-name-container">
                <span v-if="onlineImg.extension === 'pdf'" class="file-name" >
                    <a :href="onlineImg.imgPath" target="_blank" >{{ onlineImg.fileName }}</a></span>
                <span v-if="onlineImg.extension !== 'pdf'" class="file-name" >{{ onlineImg.fileName }}</span>
              </el-row>
              <el-row>
                <!-- <el-button
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onPowerOfAttorneyImgCrossClick(onlineImg.id)"
                ></el-button> -->
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- powerOfAttorneyIdCardImgArr doc -->
      <el-row
      class="online-operation-block-style" style="border-bottom: 0px">
        <el-col :span="24" class="online-operation-section-header text-left">
          <h3>ด้านหน้าบัตรประชาชนของผู้รับมอบอำนาจ</h3>
        </el-col>
        <el-col :span="24">
          <div class="image-row" >
            <div class="image-col"
              :span="6"
              v-for="onlineImg in onlineData.powerOfAttorneyIdCardImgArr"
              :key="onlineImg.id"
            >
              <el-row>
                <el-image
                  v-if="onlineImg.extension !== 'pdf'"
                  v-loading="imgLoading"
                  :src="onlineImg.imgPath"
                  :class="{
                    'online-operation-img':true,
                    'online-operation-img-invalid': !onlineImg.isValid,
                    'online-operation-return-field': returnValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                  }"
                  @click="setPreviewImg(onlineImg.imgPath)"
                >
                </el-image>
                <img
                :class="{
                    'pdf-img':true,
                    'online-operation-img-invalid': !onlineImg.isValid,
                    'online-operation-return-field': returnValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      onlineImg.paramLabel,
                      onlineImg.isValid,
                      onlineImg.objectFileName
                    ),
                }"
                v-if="onlineImg.extension === 'pdf'" :src="require('@/assets/PDF.png')" alt="">
              </el-row>
              <el-row class="file-name-container">
                <span v-if="onlineImg.extension === 'pdf'" class="file-name" >
                    <a :href="onlineImg.imgPath" target="_blank" >{{ onlineImg.fileName }}</a></span>
                <span v-if="onlineImg.extension !== 'pdf'" class="file-name" >{{ onlineImg.fileName }}</span>
              </el-row>
              <el-row>
                <!-- <el-button
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onPowerOfAttorneyIdCardImgCrossClick(onlineImg.id)"
                ></el-button> -->
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>

    <!-- -ที่อยู่บนใบปะหน้าพัสดุ- -->
      <el-row class="online-operation-block-style" style="padding-top:2%; border-top: 2px solid grey;">
        <el-col :span="6" class="online-operation-section-header text-left">
          ที่อยู่บนใบปะหน้าพัสดุ
        </el-col>
        <el-col :span="18" class="text-left">
          <el-row :gutter="20">
            <el-col
              v-for="detail in onlineData.wayBillAddressInfo"
              :key="detail.key"
              :span="detail.span"
              class="online-operation-input-block-Pich"
            >
              <el-row>
                <span>{{ detail.label }}</span>
              </el-row>
              <el-row type="flex" align="middle" justify="space-between">
                <el-input
                  :value="inputFill(detail.key, detail.onlineData)"
                  :class="{
                    'online-operation-input-invalid': !detail.isValid,
                    'online-operation-return-field': returnValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                  }"
                >
                </el-input>
                <!-- <el-button
                  style="margin-left: 15px"
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onWayBillAddrCrossClick(detail.id)"
                ></el-button> -->
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- -ที่อยู่สำหรับเข้ารับพัสดุ-- -->
      <el-row class="online-operation-block-style">
        <el-col :span="6" class="online-operation-section-header text-left">
          ที่อยู่สำหรับเข้ารับพัสดุ
        </el-col>
        <el-col :span="18" class="text-left">
          <el-row :gutter="20">
            <el-col
              v-for="detail in onlineData.pickedUpInfo"
              :key="detail.key"
              :span="detail.span"
              class="online-operation-input-block-Pich"
            >
              <el-row>
                <span>{{ detail.label }}</span>
              </el-row>
              <el-row type="flex" align="middle" justify="space-between">
                <el-input
                  :value="inputFill(detail.key, detail.onlineData)"
                  :class="{
                    'online-operation-input-invalid': !detail.isValid,
                    'online-operation-return-field': returnValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                    'online-operation-reject-field': rejectValueCheck(
                      detail.paramLabel,
                      detail.isValid
                    ),
                  }"
                >
                </el-input>
                <!-- <el-button
                  style="margin-left: 15px"
                  type="danger"
                  icon="el-icon-close"
                  size="mini"
                  circle
                  @click="onPickedUpAddrCrossClick(detail.id)"
                ></el-button> -->
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

     <!-- -วันที่ต้องการส่งพัสดุ- -->
      <el-row class="online-operation-block-style">
        <el-col :span="6" class="online-operation-section-header text-left">
          วันที่ต้องการส่งพัสดุ
        </el-col>
        <el-col :span="18">
          <el-row>
            <el-col :span="24">
              <el-row class="online-operation-input-block-Pich">
                <el-row :span="6" class="text-left">
                  <span>วันที่ต้องการเริ่มส่งพัสดุ</span>
                </el-row>
                <el-row :span="18">
                  <el-input
                    :value="getDate(onlineData.pickedUpDate)"
                  ></el-input>
                </el-row>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-button @click="onlineOperationDetail.dialog = false"
            >ยกเลิก</el-button
          >
          <el-button type="danger" @click="rejectRegister()">ตีกลับ</el-button>
          <el-button
            type="success"
            @click="completeRegister()"
            :disabled="flagBtnSave"
            >ข้อมูลถูกต้อง</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog width="80%" :visible.sync="imgPreviewDialog">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-image :src="previewImgSrc" width="100%"> </el-image>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import 'dayjs/locale/th'
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra'
dayjs.extend(buddhistEra)
const initForm = {
    shopId: null,
    address: null,
    subDistrict: null,
    district: null,
    province: null,
    zipcode: null
}
export default {
    name: 'OnlineOperationRejectDialog',
    components: {
    },
    props: {
        onlineOperationDetail: {
            type: Object,
            default: () => {
            }
        }
    },
    data () {
        return {
            // srcList: [],
            returnField: [],
            onlineData: {
                committeeImgArr: [],
                powerOfAttorneyImgArr: [],
                powerOfAttorneyIdCardImgArr: []
            },
            imgLoading: false,
            dialogLoading: false,
            imgPreviewDialog: false,
            previewImgSrc: '',
            dayOptions: [
                'จันทร์',
                'อังคาร',
                'พุธ',
                'พฤหัสบดี',
                'ศุกร์',
                'เสาร์',
                'ไม่แน่นอน'
            ],
            flagBtnSave: false,
            log: {
                type: 'Shop',
                user_id: null,
                shop_id: null,
                editor_email: null,
                editor_value: null,
                payload: {
                    lhs: {},
                    rhs: {}
                },
                timestamp: null
            },
            paramForm: initForm,
            lsh: initForm,
            rejectLog: {
                type: 'User',
                user_id: null,
                shop_id: null,
                editor_email: null,
                editor_value: null,
                payload: {
                    lhs: {
                        detail: {},
                        courier: {},
                        online: {}
                    },
                    rhs: {
                        detail: {},
                        courier: {},
                        online: {}
                    }
                },
                timestamp: null
            }
        }
    },
    watch: {
        'onlineOperationDetail.dialog' (val) {
            if (val) {
                this.onlineData = this.onlineOperationDetail
                this.getImage(this.onlineData.userId, this.onlineData.userType)
                this.getReturnField()
            } else {
                this.flagBtnSave = false
                this.onlineData = {
                    dialog: false,
                    approveStatus: '',
                    userId: '',
                    userCode: '',
                    mainCourier: '',
                    pickedUpInfo: [],
                    pickedUpDate: '',
                    pickedUpDays: [''],
                    data: [],
                    currentAddressInfo: [],
                    taxInvoiceAddressInfo: [],
                    wayBillAddressInfo: [],
                    bankAccountInfo: [],
                    committeeImgArr: [],
                    powerOfAttorneyImgArr: [],
                    powerOfAttorneyIdCardImgArr: [],
                    imgArr: [{ imgPath: '' }, { imgPath: '' }, { imgPath: '' }]
                }
                this.returnField = []
            }
        }
    },
    methods: {
        inputFill (key, data) {
            if (key === 'bankAccountType') {
                return this.getBankAccountType(data)
            } else if (key === 'bankName') {
                return this.getBank(data)
            } else {
                return data
            }
        },
        onCrossClick (val) {
            this.onlineData.data[val].isValid = !this.onlineData.data[val].isValid
            this.checkFlagOnSave(this.onlineData.data)
        },
        onCurrentAddrCrossClick (val) {
            this.onlineData.currentAddressInfo[val].isValid = !this.onlineData.currentAddressInfo[val].isValid
            this.checkFlagOnSave(this.onlineData.currentAddressInfo)
        },
        onTaxAddrCrossClick (val) {
            this.onlineData.taxInvoiceAddressInfo[val].isValid = !this.onlineData.taxInvoiceAddressInfo[val].isValid
            this.checkFlagOnSave(this.onlineData.taxInvoiceAddressInfo)
        },
        onWayBillAddrCrossClick (val) {
            this.onlineData.wayBillAddressInfo[val].isValid = !this.onlineData.wayBillAddressInfo[val].isValid
            this.checkFlagOnSave(this.onlineData.wayBillAddressInfo)
        },
        onPickedUpAddrCrossClick (val) {
            this.onlineData.pickedUpInfo[val].isValid = !this.onlineData.pickedUpInfo[val].isValid
            this.checkFlagOnSave(this.onlineData.pickedUpInfo)
        },
        onBankCrossClick (val) {
            this.onlineData.bankAccountInfo[val].isValid =
        !this.onlineData.bankAccountInfo[val].isValid
            this.checkFlagOnSave(this.onlineData.bankAccountInfo)
        },
        onImgCrossClick (val) {
            this.onlineData.imgArr[val].isValid = !this.onlineData.imgArr[val].isValid
            this.checkFlagOnSave(this.onlineData.imgArr)
        },
        onJuristicImgCrossClick (val) {
            this.onlineData.juristicImgArr[val].isValid = !this.onlineData.juristicImgArr[val].isValid
            this.checkFlagOnSave(this.onlineData.juristicImgArr)
        },
        onCommitteeImgCrossClick (val) {
            let temp = this.onlineData.committeeImgArr[val]
            temp.isValid = !temp.isValid
            this.$set(this.onlineData.committeeImgArr, val, temp)
            this.checkFlagOnSave(this.onlineData.committeeImgArr)
        },
        onPowerOfAttorneyImgCrossClick (val) {
            let temp = this.onlineData.powerOfAttorneyImgArr[val]
            temp.isValid = !temp.isValid
            this.$set(this.onlineData.powerOfAttorneyImgArr, val, temp)
            this.checkFlagOnSave(this.onlineData.powerOfAttorneyImgArr)
        },
        onPowerOfAttorneyIdCardImgCrossClick (val) {
            let temp = this.onlineData.powerOfAttorneyIdCardImgArr[val]
            temp.isValid = !temp.isValid
            this.$set(this.onlineData.powerOfAttorneyIdCardImgArr, val, temp)
            this.checkFlagOnSave(this.onlineData.powerOfAttorneyIdCardImgArr)
        },
        checkFlagOnSave (data) {
            let resultSome = data.some((data) => data.isValid === false)
            if (resultSome) {
                this.flagBtnSave = true
            } else {
                if (this.onlineData.approveStatus === 7) {
                    this.flagBtnSave = true
                    return
                }
                this.flagBtnSave = false
            }
        },
        async getImage (userCode, userType) {
            this.imgLoading = true
            let documentParams = {}
            if (userType === 1) {
                documentParams = {
                    doc_types: 'company_doc,company_bank_book,vat_doc,committee_id_card,power_of_attorney,power_of_attorney_id_card',
                    user_id: userCode }
            } else {
                documentParams = {
                    doc_types: 'id_card,bank_book',
                    user_id: userCode }
            }
            try {
                let resDoc = await fgApi.document.getDocument(documentParams)
                for (const index in resDoc.data) {
                    let tempData = resDoc.data[index]
                    if (userType === 0) {
                        if (tempData.docType === 'id_card') {
                            this.onlineData.imgArr[0].imgPath = tempData.files[0].url
                            this.onlineData.imgArr[0].fileName = tempData.files[0].fileName
                            this.onlineData.imgArr[0].extension = tempData.files[0].fileName.split('.').pop()
                            this.onlineData.imgArr[0].objectFileName = tempData.files[0].objectFileName
                        }
                        if (tempData.docType === 'bank_book') {
                            this.onlineData.imgArr[1].imgPath = tempData.files[0].url
                            this.onlineData.imgArr[1].fileName = tempData.files[0].fileName
                            this.onlineData.imgArr[1].extension = tempData.files[0].fileName.split('.').pop()
                            this.onlineData.imgArr[1].objectFileName = tempData.files[0].objectFileName
                        }
                    }

                    if (userType === 1) {
                        if (tempData.docType === 'company_doc') {
                            this.onlineData.juristicImgArr[0].imgPath = tempData.files[0].url
                            this.onlineData.juristicImgArr[0].fileName = tempData.files[0].fileName
                            this.onlineData.juristicImgArr[0].extension = tempData.files[0].fileName.split('.').pop()
                            this.onlineData.juristicImgArr[0].objectFileName = tempData.files[0].objectFileName
                        }
                        if (tempData.docType === 'company_bank_book') {
                            this.onlineData.juristicImgArr[1].imgPath = tempData.files[0].url
                            this.onlineData.juristicImgArr[1].fileName = tempData.files[0].fileName
                            this.onlineData.juristicImgArr[1].extension = tempData.files[0].fileName.split('.').pop()
                            this.onlineData.juristicImgArr[1].objectFileName = tempData.files[0].objectFileName
                        }
                        if (tempData.docType === 'vat_doc' && tempData.files.length > 0) {
                            this.onlineData.juristicImgArr[2].imgPath = tempData.files[0].url
                            this.onlineData.juristicImgArr[2].fileName = tempData.files[0].fileName
                            this.onlineData.juristicImgArr[2].extension = tempData.files[0].fileName.split('.').pop()
                            this.onlineData.juristicImgArr[2].objectFileName = tempData.files[0].objectFileName
                        }
                        // -- add data to  committeeImgArr ---
                        if (tempData.docType === 'committee_id_card' && tempData.files.length > 0) {
                            for (const i in tempData.files) {
                                this.onlineData.committeeImgArr[i] = {
                                    id: i,
                                    fileName: tempData.files[i].fileName,
                                    objectFileName: tempData.files[i].objectFileName,
                                    extension: tempData.files[i].fileName.split('.').pop(),
                                    imgPath: tempData.files[i].url,
                                    paramLabel: 'committee_id_card',
                                    isValid: true
                                }
                            }
                        }
                        // -- add data to power_of_attorney ---
                        if (tempData.docType === 'power_of_attorney' && tempData.files.length > 0) {
                            for (const i in tempData.files) {
                                this.onlineData.powerOfAttorneyImgArr[i] = {
                                    id: i,
                                    fileName: tempData.files[i].fileName,
                                    objectFileName: tempData.files[i].objectFileName,
                                    extension: tempData.files[i].fileName.split('.').pop(),
                                    imgPath: tempData.files[i].url,
                                    paramLabel: 'power_of_attorney',
                                    isValid: true
                                }
                            }
                        }
                        // -- add data to power_of_attorney ---
                        if (tempData.docType === 'power_of_attorney_id_card' && tempData.files.length > 0) {
                            for (const i in tempData.files) {
                                this.onlineData.powerOfAttorneyIdCardImgArr[i] = {
                                    id: i,
                                    fileName: tempData.files[i].fileName,
                                    objectFileName: tempData.files[i].objectFileName,
                                    extension: tempData.files[i].fileName.split('.').pop(),
                                    imgPath: tempData.files[i].url,
                                    paramLabel: 'power_of_attorney_id_card',
                                    isValid: true
                                }
                            }
                        }
                    }
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
            this.imgLoading = false
        },
        rejectRegister () {
            // this.dialogLoading = true
            this.$prompt('', 'สาเหตุที่ตีกลับ', {
                confirmButtonText: 'บันทึก',
                cancelButtonText: 'ยกเลิก',
                inputType: 'textarea'
                // inputValidator: this.validateInputConfirmSubmit
            }).then(async (val) => {
                console.log('promt val', val)
                console.log('userId', this.onlineData.userId)
                let apParams = {
                    user_id: this.onlineData.userId,
                    approve_status: 7
                }

                let dataPayload = {}
                if ((this.onlineData.approveStatus !== 9) && (this.onlineData.approveStatus !== 8)) {
                    if (this.returnField !== null) {
                        dataPayload = this.returnField
                    }
                }

                for (const onlineIndex in this.onlineData.data) {
                    if (!this.onlineData.data[onlineIndex].isValid) {
                        dataPayload[this.onlineData.data[onlineIndex].paramLabel] = this.onlineData.data[onlineIndex].onlineData
                    }
                }
                for (const onlineIndex in this.onlineData.bankAccountInfo) {
                    if (!this.onlineData.bankAccountInfo[onlineIndex].isValid) {
                        dataPayload[this.onlineData.bankAccountInfo[onlineIndex].paramLabel] =
                        this.onlineData.bankAccountInfo[onlineIndex].onlineData
                    }
                }

                // --current adderss--
                for (const onlineIndex in this.onlineData.currentAddressInfo) {
                    if (!this.onlineData.currentAddressInfo[onlineIndex].isValid) {
                        dataPayload[this.onlineData.currentAddressInfo[onlineIndex].paramLabel] =
                        this.onlineData.currentAddressInfo[onlineIndex].onlineData
                    }
                }

                // --tax invoice address--
                for (const onlineIndex in this.onlineData.taxInvoiceAddressInfo) {
                    if (!this.onlineData.taxInvoiceAddressInfo[onlineIndex].isValid) {
                        dataPayload[this.onlineData.taxInvoiceAddressInfo[onlineIndex].paramLabel] =
                        this.onlineData.taxInvoiceAddressInfo[onlineIndex].onlineData
                    }
                }

                // --wayBillAddressInfo--
                for (const onlineIndex in this.onlineData.wayBillAddressInfo) {
                    if (!this.onlineData.wayBillAddressInfo[onlineIndex].isValid) {
                        dataPayload[this.onlineData.wayBillAddressInfo[onlineIndex].paramLabel] =
                        this.onlineData.wayBillAddressInfo[onlineIndex].onlineData
                    }
                }

                // --pickedUpInfo--
                for (const onlineIndex in this.onlineData.pickedUpInfo) {
                    if (!this.onlineData.pickedUpInfo[onlineIndex].isValid) {
                        dataPayload[this.onlineData.pickedUpInfo[onlineIndex].paramLabel] =
                        this.onlineData.pickedUpInfo[onlineIndex].onlineData
                    }
                }

                // --- ordinary doc ---
                let temp = []
                for (const onlineIndex in this.onlineData.imgArr) {
                    if (!this.onlineData.imgArr[onlineIndex].isValid) {
                        temp = []
                        temp.push({
                            file_name: (this.onlineData.imgArr[onlineIndex].fileName === 'none') ? 'required' : this.onlineData.imgArr[onlineIndex].fileName,
                            object_file_name: this.onlineData.imgArr[onlineIndex].objectFileName
                        })
                        dataPayload[this.onlineData.imgArr[onlineIndex].paramLabel] = temp
                    }
                }

                // --- juristic doc ---
                temp = []
                for (const onlineIndex in this.onlineData.juristicImgArr) {
                    if (!this.onlineData.juristicImgArr[onlineIndex].isValid) {
                        temp = []
                        temp.push({
                            file_name: (this.onlineData.juristicImgArr[onlineIndex].fileName === 'none') ? 'required' : this.onlineData.juristicImgArr[onlineIndex].fileName,
                            object_file_name: this.onlineData.juristicImgArr[onlineIndex].objectFileName
                        })
                        dataPayload[this.onlineData.juristicImgArr[onlineIndex].paramLabel] = temp
                    }
                }

                // --committeeImgArr--
                temp = []
                for (const onlineIndex in this.onlineData.committeeImgArr) {
                    if (!this.onlineData.committeeImgArr[onlineIndex].isValid) {
                        temp.push({
                            file_name: (this.onlineData.committeeImgArr[onlineIndex].fileName === 'none') ? 'required' : this.onlineData.committeeImgArr[onlineIndex].fileName,
                            object_file_name: this.onlineData.committeeImgArr[onlineIndex].objectFileName
                        })
                    }
                }
                if (temp.length > 0) {
                    dataPayload['committee_id_card'] = temp
                }

                // --powerOfAttorneyImgArr--
                temp = []
                for (const onlineIndex in this.onlineData.powerOfAttorneyImgArr) {
                    if (!this.onlineData.powerOfAttorneyImgArr[onlineIndex].isValid) {
                        temp.push({
                            file_name: (this.onlineData.powerOfAttorneyImgArr[onlineIndex].fileName === 'none') ? 'required' : this.onlineData.powerOfAttorneyImgArr[onlineIndex].fileName,
                            object_file_name: this.onlineData.powerOfAttorneyImgArr[onlineIndex].objectFileName
                        })
                    }
                }
                if (temp.length > 0) {
                    dataPayload['power_of_attorney'] = temp
                }

                // --powerOfAttorneyIdCardImgArr--
                temp = []
                for (const onlineIndex in this.onlineData.powerOfAttorneyIdCardImgArr) {
                    if (!this.onlineData.powerOfAttorneyIdCardImgArr[onlineIndex].isValid) {
                        temp.push({
                            file_name: (this.onlineData.powerOfAttorneyIdCardImgArr[onlineIndex].fileName === 'none') ? 'required' : this.onlineData.powerOfAttorneyIdCardImgArr[onlineIndex].fileName,
                            object_file_name: this.onlineData.powerOfAttorneyIdCardImgArr[onlineIndex].objectFileName
                        })
                    }
                }
                if (temp.length > 0) {
                    dataPayload['power_of_attorney_id_card'] = temp
                }

                let params = {
                    user_id: this.onlineData.userId,
                    payload: dataPayload
                }

                if (Object.entries(dataPayload).length < 1) {
                    this.$message({
                        message: 'กรุณาเลือกข้อมูลที่ต้องการตีกลับ',
                        type: 'warning',
                        showClose: true
                    })
                } else {
                    // console.log('dataPayload', dataPayload)
                    // console.log('params', params)
                    try {
                        let apRes = await fgApi.user.upDateApproveStatus(apParams)
                        let res = await fgApi.log.setInvalidShopData(params)
                        if (apRes.success && res.success) {
                            console.log('Reject successfull')
                            this.$emit('close')
                            this.$message({
                                message: 'การตีกลับข้อมูลเสร็จสมบูรณ์',
                                type: 'success',
                                showClose: true
                            })
                            // reject log set
                            // console.log('dataPayload', dataPayload)
                            this.rejectLog.payload.lhs.online = dataPayload
                            this.rejectLog.editor_email = this.$store.get('user/objUser').email
                            this.rejectLog.editor_value = val.value
                            this.rejectLog.user_id = this.onlineData.userId
                            this.rejectLog.timestamp = this.$dayjs().unix()
                            fgApi.log.setLogFinance(this.rejectLog)
                            this.onlineOperationDetail.dialog = false
                        } else {
                            console.log(apRes.message)
                            console.log(res.message)
                        }
                    } catch (error) {
                        this.$notify.error({
                            title: 'Error',
                            message: error
                        })
                    }
                }
            })

            // this.dialogLoading = false
            // this.onlineOperationDetail.dialog = false
        },
        async setLog () {
            console.log(this.onlineData)
            let paramSearchShop = {
                target_user_id: this.onlineData.userId,
                search: '',
                limit: null,
                offset: null
            }
            try {
                let resShopSeach = await fgApi.shop.searchListShop(paramSearchShop)
                if (resShopSeach.success) {
                    let shopDetail = resShopSeach.data[0]
                    for (const key in this.paramForm) {
                        this.lsh[key] = shopDetail[key]
                    }
                    console.log(this.lsh)
                    let dataPickUpInfo = {}
                    this.onlineData.pickedUpInfo.forEach((e) => {
                        dataPickUpInfo[e.key] = e.onlineData
                    })
                    let paramUpdate = {
                        shopId: shopDetail.shopId,
                        address: dataPickUpInfo.pickedUpAddress,
                        subDistrict: dataPickUpInfo.pickedUpSubDistrict,
                        district: dataPickUpInfo.pickedUpDistrict,
                        province: dataPickUpInfo.pickedUpProvince,
                        zipcode: dataPickUpInfo.pickedUpZipcode
                    }

                    let resUpdateShop = await fgApi.shop.updateShop(paramUpdate)
                    if (resUpdateShop.success) {
                        this.log.payload.lhs = this.lsh
                        this.log.payload.rhs = paramUpdate
                        this.log.editor_email = this.$store.get('user/objUser').email
                        this.log.editor_value = 'Online Operation'
                        this.log.shop_id = this.paramForm.shopId
                        this.log.timestamp = this.$dayjs().unix()
                        fgApi.log.setLogFinance(this.log)
                    } else {
                        this.$message.error('Oops, Api Error.')
                    }
                }
            } catch (error) {
                this.$message.error('Oops, Api Error.')
            }
        },
        async completeRegister () {
            this.dialogLoading = true

            let params = {
                user_id: this.onlineData.userId,
                approve_status: 8
            }
            try {
                let res = await fgApi.user.upDateApproveStatus(params)
                if (res.success) {
                    // await this.setLog()
                    console.log('Approve successfull')
                    this.$emit('close')
                    this.$message({
                        message: 'การตรวจสอบข้อมูลลูกค้าประจำเสร็จสมบูรณ์',
                        type: 'success',
                        showClose: true
                    })
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: res.message
                    })
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
            this.dialogLoading = false
            this.onlineOperationDetail.dialog = false
        },
        getDate (date) {
            return dayjs(date).locale('th').format('DD/MM/YYYY ( DD MMMM BBBB)')
        },
        async getReturnField () {
            this.dialogLoading = true
            let param = {
                user_id: this.onlineData.userId
            }
            try {
                let res = await fgApi.user.getInvalidShopData(param)
                // console.log('invalid field:::', res)
                if (res.success) {
                    this.returnField = res.data.invalid_shop_data
                    if (this.onlineData.approveStatus === 7 && this.returnField) {
                        this.flagBtnSave = true
                    }
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: res.message
                    })
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
            this.dialogLoading = false
        },
        returnValueCheck (val, validChecker, objectFileName) {
            if (this.onlineData.approveStatus === 9 && validChecker) {
                if ((val === 'committee_id_card') || (val === 'power_of_attorney') || (val === 'power_of_attorney_id_card')) {
                    for (const i in this.returnField[val]) {
                        if (this.returnField[val][i].object_file_name === objectFileName) {
                            return true
                        }
                    }
                    return false
                } else {
                    let field = this.returnField[val]
                    if (field !== undefined) {
                        // console.log('field', field)
                        return true
                    }
                }
            } else {
                return false
            }
        },
        rejectValueCheck (val, validChecker, objectFileName) {
            if (this.onlineData.approveStatus === 7 && validChecker) {
                if ((val === 'committee_id_card') || (val === 'power_of_attorney') || (val === 'power_of_attorney_id_card')) {
                    for (const i in this.returnField[val]) {
                        if (this.returnField[val][i].object_file_name === objectFileName) {
                            return true
                        }
                    }
                    return false
                } else {
                    let field = this.returnField[val]
                    if (field !== undefined) {
                        // console.log('field', field)
                        return true
                    }
                }
            } else {
                return false
            }
        },
        setPreviewImg (imgPath) {
            this.imgPreviewDialog = true
            this.previewImgSrc = imgPath
        }
    },
    computed: {
        updateCurrentAddr () {
            return this.onlineData.currentAddressInfo
        }
    }
}
</script>

<style lang="scss" scope>
$base-font-family: "Prompt";
$base-font-size-title: 16px;
$base-font-color-field: #646b7d;
$base-font-color-reject: #ff2332;
$base-font-color-reject-bg: #ffeeef;
.image-row{
    display: flex;
    flex-wrap:wrap;
    justify-content:left;
    .image-col{
        width: 185px;
    }
}
.pdf-img{
    width: 100px;
}
.file-name{
    font-size: 12px;
    //  white-space: nowrap;
}
.file-name-container{
    line-height: 1.5em;
    height: 3em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
   padding: 0px 20px;
   min-height: 40px;
   max-height: 40px;
}
.asterisk {
// padding-left: 5px;
color: red;
}

.online-operation-section-header {
  font-size: 20px;
  font-weight: 700;
}
.online-operation-input-block-Pich {
  margin: 5px 0;
}
.online-operation-input-invalid {
  outline-style: solid !important;
  outline-color: red !important;
}
.online-operation-img{
    cursor: pointer !important;
    height: 100px !important;
    width: 100px!important;
}
.online-operation-img-invalid {
  outline-style: solid !important;
  outline-color: red !important;
}
.online-operation-return-field {
  outline-style: solid !important;
  outline-color: green !important;
}
.online-operation-reject-field {
  outline-style: solid !important;
  outline-color: rgb(185, 63, 63) !important;
//  outline-color: rgb(85, 63, 185) !important;
}
.online-operation-block-style {
  margin-bottom: 2%;
  padding-bottom: 2%;
  border-bottom: 2px solid grey;
}
</style>
